import { BRANDS } from "@/constants/content";

export default function BrandMarquee() {
  const items = BRANDS;
  return (
    <section className="border-y border-ink/10 bg-white py-7" data-testid="brand-marquee">
      <p className="eyebrow mb-5 text-center text-slate-400">Factory-trained on every major brand</p>
      <div className="marquee relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="marquee-track items-center gap-10 pr-10">
          {[0, 1].map((dup) => (
            <div key={dup} className="flex items-center gap-10 pr-10" aria-hidden={dup === 1}>
              {items.map((b) => (
                <span key={b} className="flex items-center gap-10">
                  <span className="font-display whitespace-nowrap text-xl font-bold tracking-tight text-ink/75 sm:text-2xl">
                    {b}
                  </span>
                  <span className="h-1.5 w-1.5 rotate-45 rounded-[2px] bg-brandsky/70" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}